import {ModalBase, Text, TextButton} from '../1elements'
import Warning from '../1elements/Icons/js/Warning'
import ButtonLayoutDiv from '../4layout/ButtonLayoutDiv'
import Box from '@mui/material/Box'

const LeaveFormModal = ({open, setOpen, leaveHandler, hint}) => {
    const closeHandler = () => {
        setOpen(false)
    }
    return(
        <ModalBase open={open} setOpen={setOpen} sx={{ padding: '30px' }}>
            <Box sx={{ alignItems: 'center', display: 'flex' }}>
                <Warning style={{ marginRight: '20px', width: '50px' }}/>
                <div>
                    <Text type={'adminDashboardTabHeader'}>You have unsaved work.</Text>
                    <Text>Are you sure you want to leave this page?</Text>
                    <Text>{hint}</Text>
                </div>
            </Box>
            <ButtonLayoutDiv>
                <TextButton clickHandler={closeHandler}>Stay</TextButton>
                <TextButton clickHandler={leaveHandler}>Leave</TextButton>
            </ButtonLayoutDiv>
        </ModalBase>
    )
}

export default LeaveFormModal
